import React from 'react'
import { Button, type ButtonProps } from '~/components/button'

type TModalFooterProps = {
  children: React.ReactNode
  orientation?: 'vertical' | 'horizontal'
} & Partial<React.HTMLAttributes<HTMLDivElement>>

interface TButtonFooterProps
  extends Omit<
    ButtonProps,
    'variant' | 'full' | 'size' | 'onClick' | 'children'
  > {
  onClick?: () => void
  children: string
}

export function ModalFirstButtonFooter({
  onClick,
  children,
  ...rest
}: TButtonFooterProps) {
  return (
    <Button.Root
      {...rest}
      full
      variant="brand-primary"
      size="lg"
      onClick={onClick}
      data-testid={rest.id}
    >
      {children}
    </Button.Root>
  )
}

export function ModalSecondButtonFooter({
  onClick,
  children,
  ...rest
}: TButtonFooterProps) {
  return (
    <Button.Root
      {...rest}
      full
      variant="neutral-secondary"
      size="lg"
      onClick={onClick}
      data-testid={rest.id}
    >
      {children}
    </Button.Root>
  )
}

export function ModalFooter({
  children,
  orientation = 'horizontal',
  ...rest
}: TModalFooterProps) {
  const renderInternalFooterChildrens = React.Children.toArray(children).filter(
    child =>
      React.isValidElement(child) &&
      (child.type === ModalFirstButtonFooter ||
        child.type === ModalSecondButtonFooter)
  ) as React.ReactElement[]

  if (orientation === 'horizontal') {
    renderInternalFooterChildrens.sort((a, b) =>
      a.type === ModalSecondButtonFooter ? -1 : 1
    )
  } else {
    renderInternalFooterChildrens.sort((a, b) =>
      a.type === ModalFirstButtonFooter ? -1 : 1
    )
  }

  const classNameByOrientationFooter = () => {
    if (orientation === 'horizontal') {
      return 'flex w-[100%] max-w-[720px] flex-row items-center justify-center ml-auto mr-auto gap-fourpulse bg-[transparent] pt-fourpulse pr-fourpulse pb-fourpulse pl-fourpulse'
    }
    return 'flex w-[100%] max-w-[360px] flex-col items-center justify-center ml-auto mr-auto gap-fourpulse bg-[transparent] pt-fourpulse pr-fourpulse pb-fourpulse pl-fourpulse'
  }

  return (
    <div
      {...rest}
      data-testid={rest.id}
      className="rounded-tl-none rounded-tr-none rounded-br-mediumcontainer rounded-bl-mediumcontainer border-[#e6e6e6] border-t-none border-r-quarterpulse border-b-quarterpulse border-l-quarterpulse bg-[#FFF]"
    >
      <div className={classNameByOrientationFooter()}>
        {renderInternalFooterChildrens?.slice(0, 2)}
      </div>
    </div>
  )
}
